import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Projects.module.scss';
import ProjectList from '~/component/ProjectItem/ProjectList';
import { getData, postData } from '~/helper/apiService';
import { ModalOverLayContext } from '~/component/Context/ModalOverLayProvider';
import ConfirmModal from '~/component/ConfirmModal';
import useMeta from '~/hooks/useMeta';
import TitleComp2 from '~/component/TitleComp2';

const cx = classNames.bind(styles);

function Projects() {
  const [projects, setProjects] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  useMeta({
    title: 'Danh sách dự án - Ngô Gia Quyến',
    metas: [
      { name: 'description', content: 'Xem danh sách các dự án nổi bật mà chúng tôi đã thực hiện. Chất lượng, uy tín, và hiệu quả.' },
      { name: 'keywords', content: 'dự án, portfolio, công trình, sản phẩm, đã thực hiện, thành tựu' },
      { property: 'og:title', content: 'Danh sách dự án - My Website' },
      { property: 'og:description', content: 'Khám phá các dự án đã hoàn thành của chúng tôi với chất lượng và sự tận tâm.' },
      { property: 'og:image', content: 'https://example.com/du-an-thumbnail.png' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://example.com/du-an' },
    ],
  });

  const loadData = async () => {
    try {
      const [projectsData, typesData] = await Promise.all([
        getData('/projects/read'),
        getData('/projects/readType'),
      ]);
      if (Array.isArray(projectsData)) {
        setProjects(projectsData);
      }
      if (typesData && Array.isArray(typesData)) {
        setProjectTypes(typesData);
      }
    } catch (error) {
      console.error('Error loading data:', error);
    }
  };

  const handleRemoveProject = async (id) => {
    const formData = new FormData();
    formData.append('id', id);
    const res = await postData('/projects/delete', formData);
    if (res.status === 'success') {
      setModalComponentContent(null);
      loadData();
    }
  };

  const handleShowConfirm = (e, id) => {
    e.preventDefault();
    setModalComponentContent(
      <ConfirmModal
        title="Xác nhận xóa"
        handleConfirm={() => handleRemoveProject(id)}
        handleCancel={() => setModalComponentContent(null)}
      />,
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  // Group projects by type_id
  const groupedProjects = projectTypes.reduce((acc, type) => {
    acc[type.id] = projects.filter((project) => project.type_id === type.id);
    return acc;
  }, {});

  return (
    <div className={cx('project-container')}>
      {projectTypes.length > 0 ? (
        projectTypes.map((type) => (
          <div key={type.id} className={cx('project-type-section')}>
            <TitleComp2 className={cx('title')}>
              {type.name || `Loại dự án ${type.id}`}
            </TitleComp2>
            {groupedProjects[type.id]?.length > 0 ? (
              <ProjectList data={groupedProjects[type.id]} handleRemove={handleShowConfirm} />
            ) : (
              <p>Chưa có dự án thuộc loại này.</p>
            )}
          </div>
        ))
      ) : (
        <p>Đang tải loại dự án...</p>
      )}
    </div>
  );
}

export default Projects;